import { useStore as baseStore } from 'vuex';
import { useStoreKey } from '@/store';

/**
 * 组合式获取类型化的stroe
 * @returns 
 */
export default function useStore () {
  return baseStore(useStoreKey)
}